<script>
import { DateElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/date-element-mixin";
import {
  DigitalProductCardElementMixin,
} from "%/dynamic-component-editor/standard-components/digital-product-card/digital-product-card-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
export default {
  name: "DigitalProductStartDate",
  extends: TextElement,
  mixins: [DateElementMixin, DigitalProductCardElementMixin],
  elementPanelSettings: {
    displayName: "Start Date",
    displayIcon: "text",
    elementGroup: "digitalProductElements",
    elementType: "element",
  },
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.formattedDate(this.entity.startAvailableForPurchaseTimestamp);
    },
  },
};
</script>
